import { render, staticRenderFns } from "./Citylink.vue?vue&type=template&id=140a1618&scoped=true"
import script from "./Citylink.vue?vue&type=script&lang=js"
export * from "./Citylink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140a1618",
  null
  
)

export default component.exports